import angular from 'angular';
import onboardingBranding from './onboardingBranding';

export default angular
  .module('components.onboardingBranding', [])
  .component('onboardingBranding', onboardingBranding).name;
